import { type FC } from 'react'

import { Box, Card, Grid, Skeleton, Stack, useIsMobileVariant } from '@dhl-ui/components'
import { ServicepointMapSkeleton, ServicepointOpeningTimesSkeleton } from '@dhl/receiver-servicepoint'

export const ServicepointCloserByContentSkeleton: FC = () => {
  const isMobileVariant = useIsMobileVariant()

  return (
    <Stack spacing={3}>
      <Card>
        <Card.Content>
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Stack alignItems="center" spacing={2}>
              <Skeleton variant="rounded" width={160} height={160} />
              <Skeleton variant="text" width={200} height={28} />
              <Skeleton variant="text" width={250} height={20} />
            </Stack>
          </Box>
        </Card.Content>
      </Card>
      <Card>
        <Card.Content>
          <Stack spacing={3}>
            <Grid container gap={isMobileVariant ? 2 : 0}>
              <Grid size={{ xs: 12, md: 6 }}>
                <Stack spacing={2}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Skeleton variant="circular" width={40} height={40} />
                    <Stack>
                      <Skeleton variant="text" width={140} height={24} />
                      <Skeleton variant="text" width={200} height={20} />
                    </Stack>
                  </Stack>

                  <Stack spacing={1}>
                    <Skeleton variant="text" width={120} height={24} />
                    <ServicepointOpeningTimesSkeleton />
                  </Stack>
                </Stack>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <ServicepointMapSkeleton />
              </Grid>
            </Grid>
          </Stack>
        </Card.Content>
      </Card>
    </Stack>
  )
}
